module.exports = __webpack_public_path__ + "static/elsaM_screen02-7510d3c63f698df06d83f68c2ac5fe66.jpg";